var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "arrowInCircle",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6,
    d: "M4.451 9.333a13.328 13.328 0 0 1 11.55-6.667c7.364 0 13.333 5.97 13.333 13.333s-5.969 13.333-13.333 13.333a13.329 13.329 0 0 1-11.55-6.667"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6,
    d: "M16 21.333 21.333 16 16 10.667M2.667 16h18.667"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrowLongLeft",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.123 17.356-1.529-1.039 29.072-.001v-.813l-28.89.001 1.44-.828-.405-.705-3.314 1.904 3.168 2.154.458-.673z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrowLongRight",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.877 14.462 1.529 1.039-29.072.001v.813l28.89-.001-1.44.828.405.705 3.314-1.904-3.168-2.154-.458.673z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrowShortLeft",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "m20 24-8-8 8-8"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrowShortRight",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "m12 24 8-8-8-8"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "calendarCheck",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M28 13.333H4m24 3.334v-4.933c0-2.24 0-3.36-.436-4.216a3.991 3.991 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436H10.4c-2.24 0-3.36 0-4.216.436a3.991 3.991 0 0 0-1.748 1.748C4 8.374 4 9.494 4 11.734v11.2c0 2.24 0 3.36.436 4.216a3.991 3.991 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436H16m5.333-26.667V8M10.667 2.667V8m8.666 17.333L22 28l6-6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.2,
    d: "M24 8 8 24M8 8l16 16"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "logIn",
    viewBox: "0 0 30 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.92,
    d: "M18.88 3.52h1.152c1.613 0 2.419 0 3.036.314.542.276.982.717 1.259 1.259.314.616.314 1.423.314 3.035v8.064c0 1.613 0 2.419-.314 3.036a2.885 2.885 0 0 1-1.259 1.259c-.616.314-1.423.314-3.036.314H18.88M14.08 7.36l4.8 4.8m0 0-4.8 4.8m4.8-4.8H7.36"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.353,
    d: "M4 16h24M4 8h24M4 24h24"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "moon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.656 17.393c-.904.24-1.834.361-2.769.361-2.847 0-5.52-1.107-7.528-3.115a10.712 10.712 0 0 1-2.752-10.298 1.33 1.33 0 0 0-.943-1.63 1.345 1.345 0 0 0-.69 0 13.346 13.346 0 0 0-5.985 3.443c-5.197 5.197-5.197 13.657 0 18.857a13.26 13.26 0 0 0 9.429 3.907 13.252 13.252 0 0 0 9.427-3.905 13.334 13.334 0 0 0 3.444-5.988 1.325 1.325 0 0 0-.346-1.285 1.34 1.34 0 0 0-1.285-.346zm-3.696 5.735a10.594 10.594 0 0 1-7.542 3.124 10.585 10.585 0 0 1-7.544-3.125c-4.157-4.159-4.157-10.927 0-15.085a10.562 10.562 0 0 1 2.747-1.977 13.365 13.365 0 0 0 3.854 10.464 13.29 13.29 0 0 0 10.464 3.854 10.704 10.704 0 0 1-1.979 2.745z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "pencil",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6,
    d: "m3.333 28.667 7.399-2.846c.473-.182.71-.273.931-.392.197-.106.384-.227.56-.364.198-.154.378-.333.736-.692l15.04-15.04A3.77 3.77 0 1 0 22.666 4L7.626 19.04c-.359.359-.538.538-.692.736a3.902 3.902 0 0 0-.364.561c-.119.221-.21.458-.392.931l-2.846 7.399zm0 0 2.744-7.135c.196-.511.295-.766.463-.883a.665.665 0 0 1 .505-.107c.201.038.395.232.782.619l3.012 3.012c.387.387.58.58.619.782a.665.665 0 0 1-.107.505c-.117.168-.372.267-.883.463l-7.135 2.744z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M16 6.667v18.667M6.667 16h18.667"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "plusInCircle",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M16 10.667v10.667M10.667 16h10.667m7.999 0c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16C2.667 8.636 8.637 2.667 16 2.667S29.333 8.637 29.333 16z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "star",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.741 32c-.38 0-.758-.122-1.084-.365l-7.656-5.739-7.656 5.739c-.317.239-.698.366-1.089.365s-.771-.132-1.087-.373c-.316-.24-.552-.577-.673-.965s-.124-.805-.005-1.194l2.856-9.633-7.588-5.589c-.314-.243-.548-.582-.668-.971s-.119-.807.001-1.196c.121-.388.356-.726.671-.966s.695-.372 1.085-.374l9.398-.015 2.992-9.394c.123-.387.36-.724.677-.962s.697-.367 1.087-.367.771.128 1.087.367.553.575.677.962l2.941 9.394 9.446.015c.391.002.771.133 1.086.374s.55.58.671.968.121.807.002 1.196-.353.728-.668.97l-7.588 5.589 2.855 9.633c.119.389.117.806-.004 1.194s-.357.725-.673.965a1.792 1.792 0 0 1-1.092.373z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "sun",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.324 16c0 3.681 2.995 6.676 6.676 6.676s6.676-2.995 6.676-6.676S19.681 9.324 16 9.324A6.684 6.684 0 0 0 9.324 16zM16 11.991c2.211 0 4.009 1.799 4.009 4.009S18.21 20.009 16 20.009c-2.211 0-4.009-1.799-4.009-4.009S13.79 11.991 16 11.991zm-1.336 13.342h2.667v4h-2.667v-4zm0-22.666h2.667v4h-2.667v-4zm-12 12h4v2.667h-4v-2.667zm22.667 0h4v2.667h-4v-2.667zM5.625 24.484l2.827-2.829 1.887 1.885-2.827 2.829-1.887-1.885zM21.653 8.459l2.829-2.829 1.885 1.885-2.829 2.829-1.885-1.885zM8.456 10.345 5.627 7.516l1.887-1.885 2.827 2.829-1.884 1.885zm17.912 14.14-1.885 1.885-2.829-2.829 1.885-1.885 2.829 2.829z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "trash",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6,
    d: "M12 4h8M4 8h24M6.667 8l.801 12.018c.149 2.231.223 3.347.588 4.243a6 6 0 0 0 3.672 3.435c.919.304 2.037.304 4.273.304 2.236 0 3.354 0 4.273-.304a6 6 0 0 0 3.672-3.435c.365-.896.439-2.012.588-4.243L25.335 8"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "userCheck",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M21.333 24 24 26.667l5.333-5.333M16 20.667h-6c-.867 0-1.3 0-1.665.042a6.4 6.4 0 0 0-5.627 5.627c-.042.364-.042.798-.042 1.665v0M13.333 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "logOut",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.2,
    d: "M21.333 22.667 28 16m0 0-6.667-6.667M28 16H12m0-12h-1.6c-2.24 0-3.36 0-4.216.436a3.991 3.991 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a3.996 3.996 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28H12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "loginStartPage",
    viewBox: "0 0 15 15"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.75 0.75H10.65C11.9101 0.75 12.5402 0.75 13.0215 0.995235C13.4448 1.21095 13.789 1.55516 14.0048 1.97852C14.25 2.45982 14.25 3.08988 14.25 4.35V10.65C14.25 11.9101 14.25 12.5402 14.0048 13.0215C13.789 13.4448 13.4448 13.789 13.0215 14.0048C12.5402 14.25 11.9101 14.25 10.65 14.25H9.75M6 3.75L9.75 7.5M9.75 7.5L6 11.25M9.75 7.5L0.75 7.5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "starStartPage",
    viewBox: "0 0 14 14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8241 14C10.6578 14 10.4922 13.9466 10.3498 13.8403L7.00009 11.3293L3.65039 13.8403C3.51161 13.9447 3.34483 14.0005 3.17386 13.9999C3.00289 13.9993 2.83648 13.9422 2.69839 13.8369C2.56018 13.7321 2.45708 13.5845 2.40378 13.4149C2.35048 13.2454 2.34969 13.0626 2.40151 12.8925L3.6508 8.67793L0.331167 6.23275C0.193589 6.12662 0.0914162 5.97796 0.0390997 5.8078C-0.0132167 5.63764 -0.0130282 5.45459 0.0396388 5.28455C0.0927213 5.11492 0.195461 4.96702 0.333337 4.86175C0.471213 4.75648 0.637253 4.69916 0.807989 4.6979L4.91945 4.69144L6.22844 0.58142C6.28246 0.412106 6.38607 0.264848 6.5246 0.160499C6.66312 0.0561503 6.82954 0 7.00029 0C7.17104 0 7.33746 0.0561503 7.47599 0.160499C7.61451 0.264848 7.71812 0.412106 7.77214 0.58142L9.0589 4.69144L13.1914 4.6979C13.3623 4.69891 13.5286 4.75619 13.6666 4.86162C13.8046 4.96705 13.9073 5.11526 13.9602 5.2852C14.013 5.45513 14.0133 5.63815 13.9609 5.80825C13.9086 5.97835 13.8063 6.12688 13.6686 6.23275L10.349 8.67793L11.5982 12.8925C11.6502 13.0625 11.6495 13.2453 11.5963 13.4149C11.543 13.5844 11.44 13.7321 11.3018 13.8369C11.1633 13.9431 10.9959 14.0002 10.8241 14Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arRight",
    viewBox: "0 0 39 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.865 1.10971L35.7445 2.38771L0 2.38871L0 3.38871L35.5205 3.38771L33.75 4.40522L34.248 5.27222L38.3225 2.93122L34.4275 0.282713L33.865 1.10971Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arLeft",
    viewBox: "0 0 39 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.03685 4.66763L3.15734 3.38963L38.9019 3.38863V2.38863L3.38134 2.38963L5.15184 1.37213L4.65384 0.505127L0.579338 2.84613L4.47435 5.49463L5.03685 4.66763Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.f67b2097724c9d8aab1a2e1ad118cc66.svg";
export { ForwardRef as ReactComponent };